export default __webpack_public_path__ + "static/media/kitchen_popUps.4ce9c6aa.jpg";